module.exports = __webpack_public_path__ + "img/svg/steps-background.d9bddc892fc531352c3cd5b25eb329b5.svg";